import React from "react";
import { defaultFlightSlots, FlightSlotProvider } from "./create";

export const DefaultFlightSlotProvider = ({ children }) => {
  const context = React.useMemo(
    () => ({
      components: defaultFlightSlots(),
      providerName: "flights",
    }),
    []
  );
  return <FlightSlotProvider context={context}>{children}</FlightSlotProvider>;
};
